/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-06 00:41:52
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-06 20:55:28
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductsLinkProduct/service/util.ts
 */
export const translateVariant = (
  isPrimary: boolean,
  originalOptions: Array<any>,
  options: Array<any>,
  variant: Array<any>,
) => {
  if (isPrimary) {
    return variant;
  } else {
    const updatedVariant = variant.map((v) => {
      const { value, uuid } = v || {};
      const option = originalOptions.find((o) => o.uuid === uuid);
      const index = Array.isArray(option.values)
        ? option.values?.findIndex((v) => v === value)
        : -1;
      const updatedValue = options.find((o) => o.uuid === uuid)?.values[index];
      return {
        ...v,
        value: updatedValue,
      };
    });
    return updatedVariant;
  }
};
